/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Insert_EventInputs */

const en_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically Insert New Event`)
};

const fr_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer automatiquement un nouvel événement`)
};

const de_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Ereignis automatisch einfügen`)
};

const it_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci automaticamente un nuovo evento`)
};

const ru_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая вставка нового события`)
};

const es_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar automáticamente un nuevo evento`)
};

const zh_cn2_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动插入新事件`)
};

const ja_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントを自動的に挿入`)
};

const hi_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट स्वचालित रूप से डालें`)
};

const pt_pt2_options_editor_auto_insert_event = /** @type {(inputs: Options_Editor_Auto_Insert_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir novo evento automaticamente`)
};

/**
* | output |
* | --- |
* | "Automatically Insert New Event" |
*
* @param {Options_Editor_Auto_Insert_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_insert_event = /** @type {((inputs?: Options_Editor_Auto_Insert_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Insert_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_insert_event(inputs)
	if (locale === "de") return de_options_editor_auto_insert_event(inputs)
	if (locale === "it") return it_options_editor_auto_insert_event(inputs)
	if (locale === "ru") return ru_options_editor_auto_insert_event(inputs)
	if (locale === "es") return es_options_editor_auto_insert_event(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_insert_event(inputs)
	if (locale === "ja") return ja_options_editor_auto_insert_event(inputs)
	if (locale === "hi") return hi_options_editor_auto_insert_event(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_insert_event(inputs)
	return en_options_editor_auto_insert_event(inputs)
});